import React from 'react';
import { Box, Grid } from '@material-ui/core';

import BaseTopBar from 'components/elements/molecules/TopBar';
import ButtonGoBack from 'components/elements/atoms/ButtonGoBack';
import { useTranslations } from 'components/utilities';
import logo from 'assets/images/telgani_logo.png';

import useStyles from './styles';
import { useSelector } from 'react-redux';
import { carDetailSelectors } from 'store/selectors';

const TopBar = () => {
	const classes = useStyles();

	const { t } = useTranslations();

	const { params, isContext } = useSelector(carDetailSelectors.getAll);

	const path = isContext ? `car/${params.id}` : '/';

	return (
		<BaseTopBar
			title={t('register.header')}
			actions={
				<Grid container justify="space-between" alignItems="center">
					<Grid item xs="auto">
						<Box pl={1}>
							<ButtonGoBack path={path} />
						</Box>
					</Grid>
					<Grid item xs="auto">
						<Box pr={3}>
							<img src={logo} alt="Telgani" className={classes.logo} />
						</Box>
					</Grid>
				</Grid>
			}
		/>
	);
};

export default TopBar;
